export default __webpack_public_path__ + "static/media/circle_halmgubbar.83e0700e.png";